import { useDispatch, useSelector } from "react-redux";

import { saveSearchTriggerModalToggledAction } from "../../../../../../sub-modules/advanced-search/store/action-creators";
import { selectSaveSearchTriggerModalOpen } from "../../../../../../sub-modules/advanced-search/store/selectors";

import SaveSearchTriggerModalTracked from "./SaveSearchTriggerModalTracked";

type Props = {
    onConfirm?(): void;
    onCancel?(): void;
};

const SaveSearchTriggerModalContainer = ({ onConfirm, onCancel }: Props) => {
    const dispatch = useDispatch();

    const isModalOpen = useSelector(selectSaveSearchTriggerModalOpen);

    const handleModalClose = () => {
        dispatch(saveSearchTriggerModalToggledAction(false));
    };

    const handleConfirmTriggerAction = () => {
        onConfirm?.();
        handleModalClose();
    };

    const handleCancelTriggerAction = () => {
        onCancel?.();
        handleModalClose();
    };

    return (
        <SaveSearchTriggerModalTracked
            isOpen={isModalOpen}
            onConfirm={handleConfirmTriggerAction}
            onCancel={handleCancelTriggerAction}
        />
    );
};

export default SaveSearchTriggerModalContainer;
